<template>
    <div>
        <v-card flat>
            <v-alert dense outlined type="error" v-if="alertError">
                No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
            </v-alert>            
            <v-toolbar flat title>
                <v-toolbar-title class="tituloMaquinaria">Tipo Licencias</v-toolbar-title>
                <v-divider vertical class="ml-3"></v-divider>    

                <v-spacer></v-spacer>      
                <v-text-field outlined class=" pr-4"
                    label="Buscar tipo de licencia"
                    v-model="buscarTipoLicencia"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                ></v-text-field>
                <v-tooltip bottom color="#0019d8" v-if="permisos.crear">
                    <template v-slot:activator="{ on }">
                        <v-btn color="#0019d8" @click="AbrirModalRegistrarLicencia()" dark rounded v-on="on">
                            <v-icon left>fas fa-save</v-icon> Crear
                        </v-btn>
                    </template>
                    <span>Nuevo Tipo Licencia</span>
                </v-tooltip>                                      
            </v-toolbar>
            <v-data-table
                :headers="EncabezadoTablaTipoLicencia"
                :items="ArrayTipoLicencias"
                class="elevation-1"
                :search="buscarTipoLicencia"
                :footer-props="{itemsPerPageText: 'Filas por página'}"                 
                :loading="loading"
                loading-text="Cargando Datos..."                                
            >
                <template v-slot:item.action="{ item }">
                    <v-tooltip left color="#d69b01">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#d69b01" v-on="on" @click="AbrirModalEditarLicencia(item)">
                                <v-icon small>fas fa-edit</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Editar Licencia</span>
                    </v-tooltip>                                              
                    <v-tooltip left color="#D80000" v-if="permisos.eliminar">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#D80000" v-on="on" @click="AbrirModalEliminarLicencia(item)">
                                <v-icon small>fas fa-trash-alt</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Eliminar Licencia</span>
                    </v-tooltip>                                              
                </template>         
                <template v-slot:no-results>
                    <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo">
                        Licencia no existe
                    </v-alert>                        
                </template>                                   
                <template v-slot:no-data v-if="ArrayTipoLicencias.length === 0">
                    <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left" v-if="!alertError">
                        No existen tipos de licencias registradas
                    </v-alert>
                    <v-alert dense outlined type="error" v-if="alertError">
                        No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
                    </v-alert>
                </template>                                
            </v-data-table>
        </v-card>
        <!-- mostramos el circular progress cuando carguen los datos para editar una licencia -->
        <v-overlay :value="EstadoCircularProgress">
            <v-progress-circular indeterminate :size="80" :width="10" color="#ffffff"></v-progress-circular>
        </v-overlay>                      
        <RegistrarLicencia 
            :AbrirDialogoRegistrarLicencia="AbrirDialogoRegistrarLicencia" @CerrarModalRegistrarLicencia="CerrarModalRegistrarLicencia"
            :esNuevo="esNuevo" :TituloDialogo="TituloDialogo" @GetAllLicenseType="GetAllLicenseType"
            :DatosEditarLicecia="DatosEditarLicecia" :EstadoPermisoEditar="EstadoPermisoEditar"
        />
        <MensajeEliminar 
            :DialogoMensajeEliminar="DialogoMensajeEliminar" @CerrarDialogoMensajeEliminar="CerrarDialogoMensajeEliminar"
            :tituloMensajeEliminar="tituloMensajeEliminar" @Eliminar="EliminarLicencia"
            :loadingEliminarHerramientaMateriaPrima="loadingEliminarLicencia" :alertError="alertError"
        />        
    </div>    
</template>

<script>
import { mapGetters, mapActions  } from 'vuex'
import { showMessageError, showMessageSuccess } from '../../../services/sweetAlert'
import RegistrarLicencia from '../../../components/IngresoNuevaInformacion/TipoLicencia/RegistrarLicencia'
import MensajeEliminar from '../../../components/MensajeEliminar'

export default {
    components: {
        RegistrarLicencia,
        MensajeEliminar,
    },
    data() {
        return {
            EncabezadoTablaTipoLicencia:[
                {text: 'Tipo Licencia', value: 'tipo', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Descripción', value: 'descripcion', sortable: false, align: 'justify', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],                   
            buscarTipoLicencia:'',
            ArrayTipoLicencias:[],
            loading:false,
            alertError:false,
            //variables para los permisos del colaborador
            namespace:'oidcStore/',
            EstadoPermisoEditar: false,
            permisos:{
                crear:false,
                editar:false,
                eliminar:false
            },
            // nuevo tipo de licencia
            esNuevo: false,
            TituloDialogo:'',
            AbrirDialogoRegistrarLicencia: false,
            // eliminar licencia
            DialogoMensajeEliminar:false,
            tituloMensajeEliminar:'',
            loadingEliminarLicencia: false,
            IdTipoLicencia: '',
            // editar licencia
            DatosEditarLicecia:{},
            EstadoCircularProgress:false,
        }
    },

    computed: {
        ...mapGetters('oidcStore', [
            'oidcIsAuthenticated',
            'oidcUser'
        ]),      
    },    

    created() {
        this.GetAllLicenseType()
        this.ObtenerPermisosSubmenuUsuario()
    },

    methods: {
        // metodos para obtener los permisos del colaborador a este modulo
            ...mapActions('oidcStore', ['authenticateOidcSilent',
                    'signOutOidc', 'authenticateOidc']),
            async ObtenerPermisosSubmenuUsuario(role){
                if (this.$store.getters[this.namespace + 'oidcIsAuthenticated']) {
                    if(this.$store.getters['oidcStore/oidcUser'].role === 'Administrador'){
                            this.permisos.crear = true
                            this.permisos.editar = true
                            this.permisos.eliminar = true
                            return 0            
                    }else{
                        //preguntar al backend por los permisos del submenu del usuario
                            var url = 'tipodelicencia'
                            const response  = await this.$store.dispatch('PermisosSubMenu', url)
                            if(typeof response === 'undefined'){
                                this.alertError=true
                                this.loading=false
                                return 0
                            }                                                 
                            if(response.status === 200){
                                this.alertError= false
                                this.permisos = response.data         
                            }else if(response.status === 400){
                                showMessageError('Error 400','Petición mala')
                            }else if(response.status === 404){
                                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                            }else if(response.status === 500){
                                showMessageError('Error 500','Error en el servidor')            
                            }
                            return 0
                    }
                }
            },                    
        // controlamos las excepciones de las peticiones al api
            ControllerException(response){
                if(typeof response === 'undefined'){
                    this.alertError=true
                    this.loading = false
                    this.EstadoCircularProgress = false
                    this.loadingEliminarLicencia = false
                    return 0
                }if(response.status === 200){
                    this.alertError= false
                    this.loading = false                    
                    if(this.TituloDialogo === "eliminar"){
                        showMessageSuccess('¡BIEN!', 'Licencia eliminado correctamente')
                        this.TituloDialogo = ''
                        this.GetAllLicenseType()
                        this.loadingEliminarLicencia = false
                        this.CerrarDialogoMensajeEliminar()
                    }else if(this.TituloDialogo === "Editar"){
                        if(this.permisos.editar) this.EstadoPermisoEditar = this.permisos.editar
                        else this.EstadoPermisoEditar = this.permisos.editar
                        this.DatosEditarLicecia = response.data
                        this.EstadoCircularProgress = false
                        this.AbrirDialogoRegistrarLicencia = true
                    }else{
                        this.ArrayTipoLicencias = response.data
                    }
                }else if(response.status === 400){
                    showMessageError('Error 400','Petición mala')
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 401){
                    showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 404){
                    showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 500){
                    showMessageError('Error 500','Error en el servidor')            
                    this.loading = false
                    this.EstadoCircularProgress = false
                }
            },

        // obtenemos todos los tipos de licencias
            async GetAllLicenseType(){
                this.loading = true
                const response = await this.$store.dispatch('getAllLicencias')
                // controlamos las excepciones
                this.ControllerException(response)            
            },
        //metodos para registrar una nueva licencia
            AbrirModalRegistrarLicencia(){
                if(this.permisos.crear) this.EstadoPermisoEditar = this.permisos.crear
                this.esNuevo = true
                this.TituloDialogo = "Crear"
                this.AbrirDialogoRegistrarLicencia = true
            },
            CerrarModalRegistrarLicencia(){
                this.TituloDialogo = ''
                this.AbrirDialogoRegistrarLicencia = false
            },
        //metodos para eliminar una licencia
            AbrirModalEliminarLicencia(item){
                this.TituloDialogo = "eliminar"
                this.tituloMensajeEliminar = item.tipo
                this.IdTipoLicencia = item.idTIpoLicencia
                this.DialogoMensajeEliminar = true
            },
            CerrarDialogoMensajeEliminar(){
                this.DialogoMensajeEliminar = false
            },
            async EliminarLicencia(){
                this.loadingEliminarLicencia = true
                const response = await this.$store.dispatch('DeleteLicenseType', this.IdTipoLicencia)
                this.ControllerException(response)
            },
        // metodos para editar una licencia
            async AbrirModalEditarLicencia(item){
                this.EstadoCircularProgress = true
                const response = await this.$store.dispatch('GetLicenseType', item.idTIpoLicencia)
                this.esNuevo = false
                this.TituloDialogo = "Editar"
                this.ControllerException(response)
            }
    },
}
</script>